import BasePolicy from './BasePolicy'
import $store from '@/store'

export default class ImportEntryPolicy extends BasePolicy {

    beforeAll(verb, authorizable, onImportEntry, __, company_id) {
        this.is_parent_company_selected = $store.getters['company/is_parent_company_selected']

        if (this.is_parent_company_selected && authorizable.hasRole('admin'))
            return true
    }

    create(authorizable) {
        return false
    }

    edit(authorizable, onImportEntry) {
        return false
    }

    view(authorizable, onImportEntry) {
        return false
    }

    list(authorizable, onImportEntry) {
        return false
    }

    delete(authorizable, onImportEntry) {
        return false
    }

}